<app-qualifications [availableQualifications]="availableQualifications" [pageGroup]="pageGroup"
    firstLabel="Välj behörighet">
    <h2>Ansökan om behörighet i ämnen och/eller skolformer som inte ingår i din examen</h2>
    <p>Skolverket ger dig behörighet i de ämnen och skolformer som ingår i din examen. Om du vill ansöka om utökad
        behörighet att undervisa i ämnen och/eller skolformer som inte ingår i din examen kan du ansöka om dem i detta
        steg. Vill du inte ansöka om behörighet utanför det som din examen omfattar kan du klicka på knappen ”nästa” för
        att hoppa över det här momentet.</p>
    <p>Om du har något av följande kan du ansöka om utökad behörighet:</p>
    <ul>
        <li>Lång undervisningserfarenhet i ett eller flera ämnen</li>
        <li>Ämnesstudier på högskolenivå</li>
        <li>Behörighetsförklaring från Skolöverstyrelsen</li>
        <li>Kompetens för vissa ämnen i gymnasieskolan</li>
    </ul>
    <app-form-group>
        <app-link external="true"
            href="https://www.skolverket.se/regler-och-ansvar/lararlegitimation-och-forskollararlegitimation/regler-och-krav-for-lararlegitimation/larar--och-forskollararlegitimation-och-krav-for-att-fa-behorighet#h-Behorighetutoverdinexamen">
            Läs mer om behörigheter utanför examen</app-link>
        <br />
        <app-link external="true" href="https://www.skolverket.se/skolfs?id=2329">Läs mer om kompetens för vissa ämnen
            i gymnasieskolan</app-link>
    </app-form-group>
    <p>
        Gör på följande sätt:
    </p>
    <ul style="list-style: decimal;">
        <li>Välj behörighet (vissa skolformer)</li>
        <li>Välj ämne</li>
        <li>Välj inriktning (vid specialskolan)</li>
        <li>Välj sedan en eller flera grunder som du ansöker behörigheten</li>
        <li>Klicka sedan lägg till</li>
    </ul>
    <p>
        Du kan ansöka om flera ämnen men du behöver välja och lägga till vart och ett.
    </p>
</app-qualifications>
